import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { focusOutlineColors, transitionAnimation } from "../../core";
import { css } from 'styled-components';
export var listItemStateStyles = {
  focus: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-shadow: inset 0 0 0 4px ", ";\n    ", "\n  "])), function (_ref) {
    var theme = _ref.theme;
    return focusOutlineColors.getDark(theme);
  }, transitionAnimation('box-shadow')),
  disabled: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n    cursor: not-allowed;\n  "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.color.state["default"].disabled.value;
  })
};
export var listItemSelectedStyles = {
  focus: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    box-shadow: inset 0 0 0 4px ", ";\n    ", "\n  "])), function (_ref3) {
    var theme = _ref3.theme;
    return focusOutlineColors.getPrimary(theme);
  }, transitionAnimation('box-shadow')),
  disabled: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    cursor: not-allowed;\n  "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.color.state["default"].disabled.value;
  })
};